module.exports = __webpack_public_path__ + "static/media/itau.b9f80dd1.svg";